import styles from "./styles.module.scss";
import ModalLayout, { DockPosition } from "components/ModalLayout";
import { useContext, useEffect, useMemo, useState } from "react";
import ModalsManagerContext from "contexts/ModalsManager";
import { IStatus } from "dto/IStatus";
import { IPackage } from "dto/IPackage";
import statusService from "api/statusService";
import PackagesContext from "contexts/PackagesContext";
import { getCompanyId as getWorkspaceId } from "utils/getCompanyId";
import CloseIcon from "assets/icons/close.svg?react";
import StatusBadge from "components/StatusBadge";
import { ICase } from "dto/Cases/ICase";
import CasesContext from "contexts/CasesContext";
import { useLocation, useNavigate } from "react-router-dom";
import { ListType } from "dto/ListType";

const EditStatuModal = () => {
  const { modals, setModals } = useContext(ModalsManagerContext);
  const [pack, setPack] = useState<IPackage | ICase | null>(null);
  const [packageType, setPackageType] = useState("PACKAGE");
  const { mutate: setStatus } = statusService.useSetStatus();
  const { packages, setPackages } = useContext(PackagesContext);
  const { cases, setCases } = useContext(CasesContext);

  const [selectedElements, setSelectedElements] = useState<
    IPackage[] | ICase[] | null
  >(null);
  const navigate = useNavigate();

  const location = useLocation();
  const url = location.pathname;

  const filterId =
    url.split("/")[2] === "thread" ? url.split("/")[3] : url.split("/")[2];
  const listStatus =
    url.split("/")[2] === "thread" ? url.split("/")[4] : url.split("/")[3];

  const getType = () => {
    switch (url.split("/")[1]) {
      case "packages":
        return ListType.Incoming;
      case "cases":
        return ListType.Cases;
      case "clients":
        return ListType.Participants;
      case "actions":
        return ListType.Participants;
      default:
        return ListType.None;
    }
  };

  const currentWorkspaceId = getWorkspaceId() ?? "";
  const { data: statusesData } = statusService.useGetStatuses(
    currentWorkspaceId,
    getType(),
  );
  const statuses: IStatus[] = useMemo(
    () => statusesData?.data ?? [],
    [statusesData],
  );

  const closeModal = () => {
    setModals({ ...modals, hide: true });
  };

  const handleChangeFlag = (status: IStatus) => {
    if (!pack) return;

    let newPacks = packageType === "CASE" ? [...cases] : [...packages];

    if (selectedElements) {
      selectedElements.map((el) => {
        setStatus({
          OwnerId: el.Id,
          OwnerKind: el.Kind,
          StatusId: status.Id as number,
        });
        return true;
      });

      newPacks = newPacks.map((i) => {
        if (selectedElements.find((a) => a.Id === i.Id)) {
          if (status.GlobalType === 9) {
            i.isDelete = true;

            const p = i as IPackage;
            if (
              url.indexOf("packages/thread") >= 0 &&
              p.Thread &&
              url.indexOf(p.Thread?.Id) >= 0
            ) {
              navigate(`/packages/${filterId}/${listStatus}`);
            } else if (url.indexOf("packages") && url.indexOf(p.Id) >= 0) {
              navigate(`/packages/${filterId}/${listStatus}`);
            }
          } else {
            i.StatusId = status.Id;
          }
        }
        return i;
      });
    } else {
      const el = newPacks.find((c) => c.Id === pack.Id && c.Kind === pack.Kind);
      if (el) {
        setStatus({
          OwnerId: el.Id,
          OwnerKind: el.Kind,
          StatusId: status.Id as number,
        });

        if (status.GlobalType === 9) {
          el.isDelete = true;
          const p = el as IPackage;
          if (
            url.indexOf("packages/thread") >= 0 &&
            p.Thread &&
            url.indexOf(p.Thread?.Id) >= 0
          ) {
            navigate(`/packages/${filterId}/${listStatus}`);
          } else if (url.indexOf("packages") && url.indexOf(p.Id) >= 0) {
            navigate(`/packages/${filterId}/${listStatus}`);
          }
        } else {
          el.StatusId = status.Id;
        }
      }
    }

    if (packageType === "CASES") {
      setCases(newPacks as ICase[]);
    } else {
      setPackages(newPacks as IPackage[]);
    }

    setModals({ ...modals, hide: true });
  };

  useEffect(() => {
    const item = localStorage.getItem("package");
    const items = localStorage.getItem("packages");
    const type = localStorage.getItem("packageType");
    if (!item) return;
    console.log(item);
    setPack(JSON.parse(item));
    localStorage.removeItem("package");

    if (items) {
      setSelectedElements(JSON.parse(items));
      localStorage.removeItem("packages");
    }

    if (!type) return;
    setPackageType(type);
    localStorage.removeItem("packageType");
  }, []);

  return (
    <ModalLayout
      dock={DockPosition.DISABLED}
      off={true}
      customX={8}
      customY={0}
      ignore
      isAnimation
      fullHeight={true}
      name="editStatusModal"
    >
      <div className={styles.wrapper}>
        <div className={styles.title}>
          Status
          <CloseIcon
            onClick={() => {
              closeModal();
            }}
            className={styles.closeIcon}
          />
        </div>
        <div className={styles.content}>
          <div
            onClick={() =>
              handleChangeFlag({
                Id: null,
                Color: 1,
                Name: "",
                Type: 1,
                Global: false,
              })
            }
            className={`${styles.box} ${
              pack?.StatusId === null && styles.active
            }`}
          >
            <CloseIcon />
            Bez statusu
          </div>
          {statuses?.map((status) => {
            return (
              <div
                onClick={() => handleChangeFlag(status)}
                className={`${styles.box} ${
                  pack?.StatusId === status?.Id && styles.active
                }`}
              >
                <StatusBadge status={status} />
                {status.Name}
              </div>
            );
          })}
        </div>
      </div>
    </ModalLayout>
  );
};

export default EditStatuModal;
